/** Acima disso, permanência parada no campo de visão passa a ser digno de nota
 *  (possível vadiagem/loitering na portaria). Sem base estatística ainda — ajustar
 *  quando tivermos volume real de câmeras que enviam esse dado. */
export const LOITERING_THRESHOLD_SECONDS = 60

export const formatStayDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds}s`
  }

  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return remainingSeconds > 0 ? `${minutes}min ${remainingSeconds}s` : `${minutes}min`
}

export const isLoitering = (seconds: number | null): boolean =>
  seconds !== null && seconds >= LOITERING_THRESHOLD_SECONDS
